import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

import store from "./app/store.js";
import { history } from "./app/history.js";

import App from "./views/App.jsx";

__webpack_nonce__ = 'a8c06518aa072d329e700608aa07f1c9'; // will be replaced by nginx with a random value

const cache = createCache({
  key: 'css',
  nonce: __webpack_nonce__, // will be replaced by nginx with a random value
  prepend: true,
});

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <CacheProvider value={cache}>
        <App />
      </CacheProvider>
    </ConnectedRouter>
  </Provider>,
  document.querySelector("#app")
);
